import React, { useState, useContext, useEffect } from "react";

import "./Schedules.css";
import "../../../ui-styles/animations/ripple.css";
import "../../../ui-styles/buttons/ButtonFilled.css";
import "../../../ui-styles/buttons/ButtonTxt.css";
import "react-datepicker/dist/react-datepicker.css";
import "../../../ui-styles/picker/picker.css";

import DropDown from "../../../lib/ui/dropdown/Dropdown";
import InputField from "../../../lib/ui/inputs/Input";
// import DatePicker from "react-datepicker";
import { LangCtx } from "../../../lib/context";

import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, } from '@material-ui/pickers';
import { KeyboardTimePicker } from "@material-ui/pickers";
import { createSlot, updateSlot } from "../../../actions/schedule";
import Loader from "../../../lib/ui/loader/Loader";
import { toast } from "react-toastify";
import { getMinutesBetweenDates } from "../../../lib/functions";

const CreateSlot = (props) =>
{

    const [ startTime, setStartTime ] = useState(new Date());
    const [ endTime, setEndTime ] = useState(new Date());
    const [ duration, setDuration ] = React.useState('');
    const [ label, setLabel ] = useState('');
    const [ loading, setLoading ] = useState(false);
    const { l } = useContext(LangCtx);
    const { scheduleData } = props;

    const durationTime = [ { value: "", label: l.duration }, { value: 15, label: "15 mins" }, { value: 30, label: "30 mins" }, { value: 45, label: "45 mins" }, { value: 60, label: "1 hour" } ];

    useEffect(() =>
    {
        if (props.data)
        {
            const { data } = props;
            // let from = new Date();
            // from.setHours(data.from / 60);
            // from.setMinutes(data.from % 60);
            // let to = new Date();
            // to.setHours(data.to / 60);
            // to.setMinutes(data.to % 60);
            setStartTime(new Date(data.from));
            setEndTime(new Date(data.to));
            setDuration(data.duration);
            setLabel(data.label);
        }
    }, [ props.data ]);
    const handleSave = () =>
    {
        let diff = getMinutesBetweenDates(startTime, endTime);
        let _day = new Date().getDay();
        if (duration === "")
        {
            toast.error(l.pls_sel_duration, {
                position: toast.POSITION.TOP_RIGHT
            });
        } else if (label === "")
        {
            toast.error(l.pls_ent_label, {
                position: toast.POSITION.TOP_RIGHT
            });
        } else if (+startTime >= +endTime)
        {
            toast.error(l.end_time_grt, {
                position: toast.POSITION.TOP_RIGHT
            });
        } else if (Number(diff) < Number(duration))
        {
            toast.error(l.duration_grt_eql, {
                position: toast.POSITION.TOP_RIGHT
            });
        } else
        {
            let flag = true;
            if (scheduleData && scheduleData.days && scheduleData.days.length === 1 && scheduleData.days[ 0 ] === _day)
            {
                let _f = new Date();
                _f.setHours(0, 0, 0, 0);
                let _t = new Date();
                _t.setHours(23, 59, 59, 99);
                _t.setDate(_t.getDate() + 7);
                if (_f.valueOf() === scheduleData.from && _t.valueOf() >= scheduleData.to)
                {
                    let st = new Date();
                    st.setHours(startTime.getHours(), startTime.getMinutes(), startTime.getSeconds(), 0);
                    if (st.valueOf() <= new Date().valueOf())
                    {
                        flag = false;
                    }
                }
            }

            if (flag)
            {
                setLoading(true);
                let obj = {
                    // from: (startTime.getHours() * 60) + startTime.getMinutes(),
                    // to: (endTime.getHours() * 60) + endTime.getMinutes(),
                    from: startTime.valueOf(),
                    to: endTime.valueOf(),
                    duration: Number(duration),
                    label: label,
                    scheduleId: props.scheduleId
                };
                if (props.data && props.data.slotId)
                {
                    updateSlot(obj, props.data.slotId).then(res =>
                    {
                        setLoading(false);
                        res && res.data ? props.handleClose(res.data) : props.handleClose(false);
                        toast.success(l.slot_updated_successfully, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                    }).catch(err =>
                    {
                        setLoading(false);
                        let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage;
                        toast.error(msg, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        //    console.log("err === ", err);
                    });
                } else
                {
                    createSlot(obj).then(res =>
                    {
                        setLoading(false);
                        toast.success('Slot created successfully', {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        props.handleClose(true);
                    }).catch(err =>
                    {
                        setLoading(false);
                        let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage ? err.errorMessage : l.went_worng_pls_try_again;
                        toast.error(msg, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        //   console.log("err === ", err);
                    });
                }
            } else
            {
                toast.error(l.start_time_should_greater_current_time, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }
    };

    return <div className="inputCard">
        {loading && <Loader />}
        <div className="flexCOl">
            <span className="HdgTxtSm">{props.data ? l.ed_slot : l.cr_slot}</span>
            <div className="respRow">
                <div className="flexMinWidthRow alignCntr mrg4">
                    <span className='minWidth'>{l.starts}</span>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardTimePicker fullWidth
                            InputProps={{ readOnly: true }}
                            className="pickerInput"
                            placeholder="08:00 AM"
                            inputVariant="outlined"
                            ampm={false}
                            value={startTime}
                            onChange={(time) => setStartTime(time)}
                            keyboardIcon={<div className="pickerIconBox inputIconBox"><img src="/images/icons/time-outline.png" className="invertGray" alt="icon" /></div>}
                        />
                    </MuiPickersUtilsProvider>
                </div>
                <div className="flexMinWidthRow alignCntr mrg4">
                    <span className='minWidth'>{l.ends}</span>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardTimePicker fullWidth
                          InputProps={{ readOnly: true }}
                            className="pickerInput"
                            placeholder="08:00 PM"
                            inputVariant="outlined"
                            ampm={false}
                            value={endTime}
                            onChange={(time) => setEndTime(time)}
                            keyboardIcon={<div className="pickerIconBox inputIconBox"><img src="/images/icons/time-outline.png" className="invertGray" alt="icon" /></div>}
                        />
                        {/* <div className="inputIconBox"><img src="/images/icons/time-outline.png" className="invertGray" alt="icon" /></div> */}
                    </MuiPickersUtilsProvider>
                </div>
                <div className="flexMinWidthRow mrg4">
                    <DropDown
                        size="fullWidth"
                        placeholder={l.duration}
                        items={durationTime}
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                    />
                </div>
                <div className="flexMinWidthRow mrg4">
                    <InputField
                        placeholder={l.label}
                        type="text"
                        value={label}
                        maxLength="30"
                        onChange={(e) => setLabel(e.target.value)}
                    />
                </div>
            </div>
        </div>
        <div className="btnGroup flxEnd">
            <div className="btnTxtGroup flxEnd">
                <button className="btnTxt md" onClick={() => props.handleClose(false)}>
                    <span>{l.cancel}</span>
                </button>
                <button className="btnTxt md" onClick={handleSave}>
                    <span>{l.save}</span>
                </button>
            </div>
        </div>
    </div>;

};
export default CreateSlot;